import FrameMacStraight from './FrameMacStraight'

export default FrameMacStraight
